import { combineReducers } from "redux";

import operation from "./operation-form";
import data from "./data-api";

export default combineReducers({
  operation,
  data,
});
